export const SITE = {
  name: "RBL EXIM",
  tagline: "Delivering Quality, Building Trust Worldwide.",
  phoneDisplay: "+91 79905 63636",
  phoneHref: "tel:+917990563636",
  whatsappDisplay: "+91 97228 55555",
  whatsappNumber: "919722855555",
  email: "info@rblexim.com",
  website: "www.rblexim.com",
  instagram: "@RBLEXIM",
  instagramUrl: "https://www.instagram.com/rblexim",
  customerCare: "+91 79905 63636",
  customerCareHref: "tel:+917990563636",
  address: "Hi Tech Industrial Park, R. S. No 102/P1, Plot No 19, Near Sokhda Chokdi, Rajkot, Gujarat, India",
  city: "Rajkot, Gujarat, India",
};

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT_MSG =
  "Hello RBL EXIM, I am interested in your food export products. I would like to discuss product availability, pricing and export requirements.";

export const productWaMsg = (name, category) =>
  `Hello RBL EXIM, I am interested in ${name} (${category}). Please share product availability, pricing, MOQ and export details. Thank you.`;
